<template>
  <div class="question-card" :class="{ 'glass-card': glassEffect }">
    <div class="question-header" v-if="title || $slots.header">
      <slot name="header">
        <h3 class="question-title">{{ title }}</h3>
      </slot>
    </div>
    
    <div class="question-content" v-if="content">
      <div v-if="rawHtml" v-html="content"></div>
      <div v-else>{{ content }}</div>
    </div>
    <slot v-else></slot>
    
    <div class="question-info" v-if="source || difficulty || $slots.info">
      <slot name="info">
        <div class="info-item" v-if="source">
          <i class="info-icon">📚</i> <span>{{ source }}</span>
        </div>
        <div class="info-item" v-if="difficulty">
          <i class="info-icon">🔥</i> <span>难度: {{ difficulty }}</span>
        </div>
      </slot>
    </div>
    
    <div class="question-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    difficulty: {
      type: String,
      default: ''
    },
    glassEffect: {
      type: Boolean,
      default: true
    },
    rawHtml: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.question-card {
  width: 100%;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  background-color: var(--card-bg, white);
  border: 1px solid var(--border-color, rgba(203, 213, 225, 0.5));
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s;
}

.question-card.glass-card {
  background-color: var(--card-bg, rgba(255, 255, 255, 0.8));
  backdrop-filter: blur(8px);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.3));
}

.question-card:hover {
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.08);
}

.question-header {
  margin-bottom: 1rem;
}

.question-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-color, #1f2937);
}

.question-content {
  margin-bottom: 1.5rem;
  line-height: 1.6;
  color: var(--text-color, #1f2937);
  white-space: pre-line;
}

.question-info {
  padding-top: 1rem;
  border-top: 1px solid var(--border-color, rgba(203, 213, 225, 0.5));
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: var(--text-secondary, #64748b);
}

.info-icon {
  margin-right: 0.5rem;
  font-style: normal;
}

.question-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color, rgba(203, 213, 225, 0.5));
}

/* 暗色主题支持 */
[data-theme="dark"] .question-card {
  background-color: var(--card-bg, #2a2a2a);
  border-color: var(--border-color, rgba(75, 85, 99, 0.5));
}

[data-theme="dark"] .question-card.glass-card {
  background-color: var(--card-bg, rgba(42, 42, 42, 0.8));
  border-color: var(--border-color, rgba(75, 85, 99, 0.3));
}

[data-theme="dark"] .question-title {
  color: var(--text-color, #e5e7eb);
}

[data-theme="dark"] .question-content {
  color: var(--text-color, #e5e7eb);
}

[data-theme="dark"] .question-info {
  border-top-color: var(--border-color, rgba(75, 85, 99, 0.5));
}

[data-theme="dark"] .info-item {
  color: var(--text-secondary, #9ca3af);
}

[data-theme="dark"] .question-footer {
  border-top-color: var(--border-color, rgba(75, 85, 99, 0.5));
}
</style> 